<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i>นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล
          </a>
        </li>
        <li class="active">นำส่งข้อมูลรายการส่งเสริมการขายเพื่อการกำกับดูแล</li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header with-border">
                <div class="layout_filter_search">
                  <h2>ตัวเลือกการค้นหา</h2>
                  <div class="pull-right box_add">
                      <el-button
                        @click="Add_uploadsave"
                        type="success"
                        size="large"
                        v-if="checkPermission"
                      >
                        <i class="fa fa-plus"></i> อัปโหลดไฟล์รายการส่งเสริมการขาย
                      </el-button>
                  </div>
                  <div class="wrapper_uploadsave">
                    <el-form size="mini">
                      <div class="row">
                          <div class="col-sm-6">
                            <el-form-item label="ประเภทรายการส่งเสริมการขาย"> 
                              <el-select style="width: 100%;" v-model="form.provider_type" placeholder="กรุณาเลือกประเภทของรายการส่งเสริมการขาย" :disabled="true" size="medium">
                                <el-option label="โทรศัพท์เคลื่อนที่" value="mobile"></el-option>
                                <el-option label="อินเทอร์เน็ตความเร็วสูงประจำที่" value="broadband"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="ชื่อผู้ให้บริการ">
                              <el-select style="width: 100%;" v-model="form.provider_id" placeholder="โปรดเลือกชื่อผู้ให้บริการ" :disabled="true" size="medium">
                                <el-option v-for="item in provider_list" :key="item.info" :value="item.info" :label="item.name"></el-option>
                              </el-select>
                            </el-form-item>
                          </div>
                          <div class="col-sm-6">
                            <el-form-item label="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)">
                              <el-date-picker
                                style="width: 100% !important"
                                v-model="form.month"
                                type="month"
                                placeholder="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)"
                              ></el-date-picker>
                            </el-form-item>
                          </div>
                      </div>
                      <div class="layout_filter_btn">
                        <el-button type="primary" size="large" @click="search">ค้นหา</el-button>
                      </div>
                    </el-form>
                  </div>
                </div>
              </div>
              <div class="box-body">
                <div class="tablelist">
                  <data-tables-server
                  @query-change="search"
                    :data="store_monthly_regulate" 
                    :total="regulate_total"
                    :page-size="form.pageSize"
                    :pagination-props="{ background: true, pageSizes: [10, 20, 50] }" 
                    style="width: 100%">
                    <el-table-column sortable="custom" prop="monthly_regulate" label="รอบการส่งข้อมูลประจำเดือน (เดือน/ปี)"></el-table-column>
                    <el-table-column prop="status" label="สถานะ"></el-table-column>
                    <el-table-column sortable="custom" prop="created_at" label="วันที่นำส่งข้อมูล"></el-table-column>
                    <el-table-column prop="namePic" label="ดาวน์โหลดไฟล์นำส่ง">
                      <template slot-scope="scope" >
                        <a class="hover" @click="request_file(scope.row.attache_file)">
                          <div class="img-radius" >
                            <img src="../../../public/img/icon-excel.jpg" alt />
                          </div>
                        </a>
                      </template>
                    </el-table-column>
                    <el-table-column prop="monthly_regulate" label="นำออกข้อมูลปัจจุบัน">
                      <template slot-scope="scope">
                        <a class="hover" v-if="scope.row.remark">
                          <el-button :disabled="pending" @click="exporting(scope.row)" type="success" icon="el-icon-upload2" circle></el-button>
                        </a>
                      </template>
                    </el-table-column>
                  </data-tables-server>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
  </div>
</template>
<script>
import {mapState,mapActions} from "vuex"
import config from "../../../config/config";
import Cookie from "cookies-js"
export default {
  created() {
    this.get_provider()
    const regex = /Operator/;
    var currentPath = this.$router.currentRoute.path;
    this.$store.dispatch('Manage_internet/get_user_info')
    if (regex.test(currentPath)) this.checkPermission = true
    var userinfo = JSON.parse(Cookie.get('user_nbtc'));
    this.form.provider_type = userinfo.provider_type
    this.form.provider_id = userinfo.provider_id
  },
  data() {
    return {
      loading : false,
      checkPermission: false,
      form: {
        page : 1,
        pageSize : 10,
        provider_type: '',
        provider_id : '',
        month: null,
        queryInfo : null
      },
      tableProps: {
        border: true
        // stripe: true,
      },
      url : config.API_URL,
      pending: false
    };
  },
  computed: {
    ...mapState({
      store_monthly_regulate : store => store.Manage_internet.prepares,
      regulate_total : store => store.Manage_internet.total,
      provider_list : store => store.ListOperator.operators,
    })
  },
  methods: {
    ...mapActions({
      get_monthly : "Manage_internet/get_monthly_regulate",
      get_provider: "ListOperator/fetch_table",
      request_file : 'Manage_internet/download_monthly_regulate'
    }),
    Add_uploadsave() {
      this.$router.push({ name: "Add_uploadsave" });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    search(queryInfo){
      this.loading = true
      this.form.page = queryInfo.page ? queryInfo.page : 1
      this.form.pageSize = queryInfo.pageSize ? queryInfo.pageSize : 5
      this.form.queryInfo = queryInfo
      this.get_monthly(this.form)
      setTimeout(() => {
        this.loading = false
      }, 250);
    },
    exporting(row){
      this.pending = true
      this.$store.dispatch('Manage_internet/export_monthly_regulate', row)
      setTimeout(()=>{
        this.pending = false
      }, 1000)
    }
  }
};
</script>
<style>
  .hover :hover{
    cursor : pointer;
  }
</style>